var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-730 -253.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M10142,2147a43.865,43.865,0,1,1,17.127-3.458A43.724,43.724,0,0,1,10142,2147Zm-9.4-45.375-3.9.4a5.873,5.873,0,0,0-4.941,3.758l-1.24,3.231a1.97,1.97,0,0,0,1.13,2.541l11.016,4.228-2.819,7.344a1.972,1.972,0,0,0,1.838,2.674,1.98,1.98,0,0,0,1.835-1.263l2.82-7.344,11.018,4.228a1.961,1.961,0,0,0,2.541-1.133l1.242-3.231a5.876,5.876,0,0,0-1.16-6.1l-2.631-2.9c0-.008-.006-.01-.01-.01a1.969,1.969,0,0,1-.389-2.035l2.65-6.9a5.9,5.9,0,0,0,4.229-11.018l-14.688-5.639a5.9,5.9,0,0,0-4.229,11.018l-2.65,6.9a1.961,1.961,0,0,1-1.649,1.252Z",
    transform: "translate(-9368 -1805)",
    fill: "#356f92"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/Pin-icon.e49febef6eceed22e0b03b51d0116099.svg";
export { ForwardRef as ReactComponent };